import { getRequest, postRequest, deleteRequest } from '../api/apiService';

const API_URL = '/api/asset-tags';

const getTagsForAsset = (assetId) => {
    if (!assetId || assetId === 'undefined') return Promise.resolve([]);
    return getRequest(`${API_URL}/asset/${assetId}`).then(response => response.data);
};

const addAssetTag = (assetTag) => {
    return postRequest(API_URL, assetTag).then(response => response.data);
};

const removeTagFromAsset = (assetId, tagId) => {
    return deleteRequest(`${API_URL}/asset/${assetId}/tag/${tagId}`);
};

const AssetTagService = {
    getTagsForAsset,
    getAssetTagsByAssetId: getTagsForAsset, // Alias
    addAssetTag,
    removeTagFromAsset,
    removeAssetTag: removeTagFromAsset, // Alias
    deleteAssetTag: (id) => deleteRequest(`${API_URL}/${id}`)
};

export default AssetTagService;
